import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { isAdminUser } from "utils/helper";
import { Table, TableFooter } from "components";
import { agentColumns, adminColumns } from "./TableColumns";
import TransactionFilterModal from "./TransactionFilterModal";
import TransactionTableHeader from "./TransactionTableHeader";
import TransactionDetailsModal from "./TransactionDetailsModal";
import { setCurrentTransaction } from "redux/actions/transactionActions";
import {
  getTransactionDetails,
  setTransactionQuery,
  clearTransactionDetails,
} from "redux/actions/transactionActions";
import TransactionDownloadModal from "./TransactionDownloadModal";
import { useLocation } from "react-router-dom";
import { ROUTES } from "routes/routePaths";

const TransactionsTable = ({ isDashboardTransactions = true }) => {
  const {
    user,
    loading,
    transactionDetails,
    queryParams,
    downloadingTransaction,
  } = useSelector((state) => ({
    user: state.user,
    loading: state.transactionsReducer.loading,
    transactionDetails: state.transactionsReducer.transactions?.content,
    queryParams: state.transactionsReducer.params,
    downloadingTransaction: state.transactionsReducer.downloadingTransaction,
  }));

  const location = useLocation();

  //This confirms the parameters we make request with.
  //Ensuring that only the recent 10 parameters are always fetched on the dashboard
  const useQuery = location.pathname !== ROUTES.dashboardTerminalStats;

  const [isFilterVisible, setIsFilterVisible] = useState(false);

  const [isDownloadVisible, setIsDownloadVisible] = useState(false);

  useEffect(() => {
    getTransactionDetails(useQuery);

    return () => {
      clearTransactionDetails();
    };
  }, [useQuery]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "size") {
      queryParams.number = 1;
    }

    setTransactionQuery({ name, value });
    getTransactionDetails();
  };

  const columns = isAdminUser(user.user) ? adminColumns : agentColumns;

  return (
    <div>
      <TransactionTableHeader
        isDashboardTransactions={isDashboardTransactions}
        setIsDownloadVisible={setIsDownloadVisible}
        setIsFilterVisible={setIsFilterVisible}
      />
      <Table
        columns={columns}
        data={transactionDetails?.content || []}
        loading={loading}
        onRowClick={
          isDashboardTransactions
            ? () => {}
            : (rowVal) => setCurrentTransaction(rowVal)
        }
      />
      {transactionDetails?.content?.length && !isDashboardTransactions ? (
        <TableFooter
          pageSize={queryParams.size}
          forcePage={queryParams.number}
          handleChange={handleChange}
          availableDataLength={transactionDetails?.content?.length}
          totalDataLength={transactionDetails?.totalElements}
          handlePageClick={(pageNo) => {
            queryParams.number = pageNo;
            getTransactionDetails();
          }}
        />
      ) : (
        ""
      )}
      <TransactionFilterModal
        isFilterVisible={isFilterVisible}
        setIsFilterVisible={setIsFilterVisible}
      />
      <TransactionDownloadModal
        isDownloadVisible={isDownloadVisible}
        setIsDownloadVisible={setIsDownloadVisible}
        downloadingTransaction={downloadingTransaction}
      />
      <TransactionDetailsModal />
    </div>
  );
};

export default TransactionsTable;
